import type { DeliveryNote } from '../delivery-notes/api';

/** `siteAddressSnapshot` is frozen JSON from the site; older or incomplete rows may carry less. */
export function formatSiteAddress(note: Pick<DeliveryNote, 'siteAddressSnapshot'>): string | null {
  const address = note.siteAddressSnapshot;

  if (address === null || typeof address !== 'object') {
    return null;
  }

  const { street, number, city, province } = address as Record<string, unknown>;
  const line = [typeof street === 'string' ? street : '', typeof number === 'string' ? number : '']
    .filter((part) => part !== '')
    .join(' ');
  const place = [city, province].filter((part): part is string => typeof part === 'string' && part !== '');
  const parts = [line, ...place].filter((part) => part !== '');

  return parts.length === 0 ? null : parts.join(', ');
}

export function itemsLabel(count: number): string {
  return count === 1 ? '1 ítem' : `${count} ítems`;
}

/** "HH:MM" in Argentina, the clock the delivery staff reads. */
export function formatClock(iso: string): string {
  return new Intl.DateTimeFormat('es-AR', {
    timeZone: 'America/Argentina/Buenos_Aires',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(iso));
}

/** Calendar-day arithmetic on `YYYY-MM-DD`, immune to the device time zone. */
export function addDays(isoDate: string, days: number): string {
  const date = new Date(`${isoDate}T12:00:00Z`);

  date.setUTCDate(date.getUTCDate() + days);

  return date.toISOString().slice(0, 10);
}
